import React from "react";
import { useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { CommonCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function DocumentsReport({ developerId, header }) {
    const params = useParams();
    const { apiData } = useAppApi(
        url_reverse("api:developer:statistics:documents_report", { developer_id: developerId, kind: params.kind })
    );

    if (!apiData) return;

    const buttons = (
        <ExportButton
            prms={{
                "main-month": apiData.forms_data.main.data.month,
                "main-year": apiData.forms_data.main.data.year,
            }}
        />
    );

    return (
        <CommonCard header={header}>
            <RenderForm buttons={buttons} />
        </CommonCard>
    );
}
